import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { AppDataService } from '../../services/app-data.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from '../../constants/app-data.constants';
import { PlacementRuleGridFilterRequest } from '../../interfaces/placement-rule-grid-filter-request.interface';
import { nameof } from '../../helpers/nameof';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';

@Component({
  selector: 'app-care-allowance-placement-rule-list',
  templateUrl: './care-allowance-placement-rule-list.component.html',
  styleUrl: './care-allowance-placement-rule-list.component.scss'
})
export class CareAllowancePlacementRuleListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.careAllowancePlacementRuleList,
      () => API_ENDPOINTS.dashboard.getCareAllowancePlacementRules,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.placementTypeFilter, null, nameof<PlacementRuleGridFilterRequest>('placementTypes'))
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.placementComponentStatusFilter, null, nameof<PlacementRuleGridFilterRequest>('placementComponentStatuses'))
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.placementLevelFilter, null, nameof<PlacementRuleGridFilterRequest>('placementLevels'))
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.placementComponentFilter, null, nameof<PlacementRuleGridFilterRequest>('placementComponents'))
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.firstSixMonthsEligibleFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.schoolAllowanceEligibleFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.targetedCareEligibleFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.inactiveDateBeforeFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementRuleListForm.inactiveDateAfterFilter, TRANSFORM.STRING_TO_DATE)
        .BuildMapper();
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.careAllowancePlacementRuleListForm.placementRuleListFilter:
        const filterRequest = this.getFilterRequest();
        this.loadGridData(filterRequest);
        break;
    }
  }

  actionButton_placementRuleGrid_datagrid_new_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacementRule.prefix]);
  }

  actionButton_placementRuleGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacementRule.prefix, event.event.data.id]);
  }

  private getFilterRequest(): PlacementRuleGridFilterRequest {
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.careAllowancePlacementRuleListForm.placementRules,
      PAGE_NUMBERS.careAllowancePlacementRuleListForm.placementRules,
      SECTION_CODES.careAllowancePlacementRuleListForm.placementRules,
      QUESTION_CODES.careAllowancePlacementRuleListForm.placementRuleListFilter
    );

    let filterRequest: PlacementRuleGridFilterRequest = this.filterQuestionToFilterModelMapper.Map(filterModel);

    return filterRequest;
  }
}
